import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
  NotificacaoGlobalDetalhe,
  NotificacoesGlobaisStatsParams,
} from '../../types/operacoes';
import {
  notificacoesGlobaisService,
  type NotificacoesGlobaisListResponse,
  type NotificacoesGlobaisParams,
  type NotificacoesGlobaisStats,
} from './services';

export const fetchNotificacoesGlobais = createAsyncThunk<
  NotificacoesGlobaisListResponse,
  NotificacoesGlobaisParams | undefined,
  { rejectValue: string }
>('notificacoesGlobais/fetchList', async (params, { rejectWithValue }) => {
  try {
    return await notificacoesGlobaisService.list(params);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar notificações',
    );
  }
});

export const fetchNotificacoesGlobaisStats = createAsyncThunk<
  NotificacoesGlobaisStats,
  NotificacoesGlobaisStatsParams | undefined,
  { rejectValue: string }
>('notificacoesGlobais/fetchStats', async (params, { rejectWithValue }) => {
  try {
    return await notificacoesGlobaisService.getStats(params);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar estatísticas',
    );
  }
});

export const fetchNotificacaoGlobalById = createAsyncThunk<
  NotificacaoGlobalDetalhe,
  string,
  { rejectValue: string }
>('notificacoesGlobais/fetchById', async (id, { rejectWithValue }) => {
  try {
    return await notificacoesGlobaisService.getById(id);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar notificação');
  }
});
